export default "__VITE_ASSET__1d8355cc__"